import { Skeleton, Stack } from '@mui/material';
import { useTheme } from '@src/themes';
import { FC } from 'react';
import { Header } from '.';
import { Text } from './text';
import { HeaderSx, TextSx } from './types';

interface DisplayValueProps {
  loading?: boolean;
  width: number;
  label: string;
  value: any;
  color?: string;
  labelColor?: string;
  valueColor?: string;
  direction?: 'row' | 'column';
  labelVariant?: 'h6' | 'h5' | 'h4' | 'h3' | 'h2' | 'h1';
  valueVariant?: 'body1' | 'body2';
  spacing?: number;
  fontSize?: string | number;
  sxDescription?: HeaderSx;
  sxValue?: TextSx;
  inCognitoMode?: boolean;
}
const DisplayValue: FC<DisplayValueProps> = ({
  loading = false,
  width,
  label,
  value,
  color,
  labelColor,
  valueColor,
  direction,
  labelVariant,
  valueVariant,
  spacing,
  fontSize,
  sxDescription,
  sxValue,
  inCognitoMode = false,
}) => {
  const { COLORS } = useTheme();

  return (
    <Stack direction={direction ?? 'column'} spacing={spacing ?? 0}>
      <Header
        variant={labelVariant ?? 'h6'}
        sx={{
          ...sxDescription,
          color: color ?? labelColor ?? COLORS.others.blackLight,
          ...(fontSize ? { fontSize } : {}),
        }}
      >
        {label}
      </Header>
      {loading ? (
        <Skeleton variant='text' width={width} height={21} />
      ) : (
        <Text
          variant={valueVariant ?? 'body1'}
          sx={{
            ...sxValue,
            color: color ?? valueColor ?? COLORS.blackLight,
            ...(fontSize ? { fontSize } : {}),
            ...(inCognitoMode ? { color: 'transparent', textShadow: '0 0 7px rgba(0,0,0,0.6)' } : {}),
          }}
        >
          {typeof value === 'function' ? value() : value}
        </Text>
      )}
    </Stack>
  );
};

export { DisplayValue };
